import React from 'react';
import Dashboard from '../components/Dashboard';

const DashboardPage: React.FC = () => {
  return <Dashboard />;
};

export default DashboardPage;
